import { get, post } from "../util/crmAxios";
import {getBasicUrls} from "../util/config";
import { agentSubjectDict } from "../util/subjectConfig";

// 根据字典类型id获取字典列表
// export const getDictionaryList = (params) => get('/base/dictionary/getDictionaryList', params);
export const getDictionaryList = ({typeId}) => {
    return new Promise(async (resolve, reject) => {
        const keyName = `DICTIONARY_${typeId}`
        //学科列表不再用这个接口
        if(typeId == 6012){
            sessionStorage.setItem(keyName, JSON.stringify(agentSubjectDict))
            resolve({
                code: 0,
                data: agentSubjectDict
            })
            return
        }
        let DictionarysList = JSON.parse(sessionStorage.getItem(keyName) || '[]');
        if ( DictionarysList.length <= 0 ) {
            DictionarysList = await get('/base/dictionary/getDictionaryList',{typeId})
            DictionarysList = DictionarysList.code === 0 ? DictionarysList.data : []
            sessionStorage.setItem(keyName, JSON.stringify(DictionarysList))
            resolve({
                code: 0,
                data: DictionarysList
            })
        } else {
            resolve({
                code: 0,
                data: DictionarysList
            })
        }
    })
    // return DictionarysList
};
//getDlRelated  知识漏洞大体检 获取DL字典
export const getDlRelated = (params) => post('/crm/dl_manager/getDlRelated', params)
// 批量分配-人员列表（学员跟进）
// export const getSubUsers = (params) => post('/crm/user/getSubUsers', params);
export const getSubUsers = (params) => {
    return new Promise(async (resolve, reject) => {
        const keyName = `CRM_SUBUSERS`
        let DictionarysList = JSON.parse(sessionStorage.getItem(keyName) || '[]');
        if ( DictionarysList.length <= 0 ) {
            DictionarysList = await post('/crm/user/getSubUsers', params)
            DictionarysList = DictionarysList.code === 0 ? DictionarysList.data : []
            sessionStorage.setItem(keyName, JSON.stringify(DictionarysList))
            resolve({
                code: 0,
                data: DictionarysList
            })
        } else {
            resolve({
                code: 0,
                data: DictionarysList
            })
        }
    })
};
// 批量分配
export const batchAssign = (params) => post('/crm/customerfollow/batchAssign', params);
// 批量分配班主任
export const crBatchAssign = (params) => post('/crm/customerfollow/crBatchAssign', params);
// 查询联系方式
export const getContactNo = (params) => get('/crm/search/getContactNo', params);
// 根据用户id获取部门树
export const getDeptTreeInfo = (params) => get('/crm/account/getDeptTreeInfo', params);
// 根据用户id获取代理商树
export const getSaleDeptTreeInfo = (params) => get('/crm/account/getSaleDeptTreeInfo', params);

// 获取人员树
export const getUserTree = (params) => get('/crm/account/getUserTree', params);
// 学员标签
export const getLabelList = (params) => get('/base/schoolmaster/label/getLabelList', params)
export const getDictionarysList = async (typeId, keyName) => {
        if(typeId == 6012){
            sessionStorage.setItem(keyName, JSON.stringify(agentSubjectDict))
            return agentSubjectDict
        }
        let DictionarysList = JSON.parse(sessionStorage.getItem(keyName) || '[]');
        if ( DictionarysList.length <= 0 ) {
            DictionarysList = await get('/base/dictionary/getDictionaryList',{typeId})
            DictionarysList = DictionarysList.code === 0 ? DictionarysList.data : []
            sessionStorage.setItem(keyName, JSON.stringify(DictionarysList))
            return DictionarysList
        }
        return DictionarysList
}
// 新增/修改列表配置
export const addOrUpdatePageListColumnsConfig = (params) => post('/crm/customer/addOrUpdatePageListColumnsConfig', params)
// 查询列表配置
export const queryPageListColumnsConfig = (params) => get('/crm/customer/queryPageListColumnsConfig', params)
// 学员ID查询联系方式
export const queryStudentMobile = (params) => post('/erp/student/queryStudentMobile', params);
// 检查学生学习中心账号
export const checkStudentAccount = (params) => post('/crm/dl_manager/checkStudentAccount', params);


// 检查校区是否存在摄像头设备
export const checkExistCameraUid = (params) => post('/base/schoolmaster/label/checkExistCameraUid', params);
// 移除校区是否存在摄像头设备
export const deleteCameraUid = (params) => post('/base/schoolmaster/label/deleteCameraUid', params);
//获取校区身份
export const checkMinusReceipt = (params) => get('/erp/order/checkMinusReceipt', params)

// 来源类别
export const OriginTypelist = (params) => get('/crm/channel/list', params);

// 查询认证
export const queryStudentInfoCertificate = (params) => get('/erp/student/queryStudentInfoCertificate', params);

// 是否强制认证
export const queryStudentDelayCertificate = (params) => get('/erp/student/queryStudentDelayCertificate', params);

// 认证学员
export const certificateStudent = (params) => post('/erp/studentdetail/certificateStudent', params);

// 验证用户验证码（专用）
export const shortMessageConfirm = (params) => post('/base/shortMessage/shortMessageConfirm', params);

// 获取验证码
export const sendVerifyShortMessage = (params) => get('/base/shortMessage/sendVerifyShortMessage', params);

// 打地基权限部门列表
export const foundationDeptTreeInfo = (params) => post('/crm/base/baseReport/foundationDeptTreeInfo', params);

// 打地基管理报告列表
export const foundationManagerReportList = (params) => post('/crm/base/baseReport/foundationManagerReportList', params);

// 全局查询学员接口
export const queryAllCustomerInfo = (params) => post('/crm/search/queryAllCustomerInfo', params);

// 文件导出 New
export const addExportRequest = (params, pageNo) => post(`/crm/export/addExportRequest?pageNo=${pageNo}`,params)

// 导出文件查询
export const queryExport = (params) => post('crm/export/queryExport', params)

// 导出文件下载
export const downLoadFile = (params) => post('crm/export/downLoadFile', params)

// 导出文件删除
export const removeDownloadFile = (params) => post('crm/export/removeDownloadFile', params)

//今日待打卡 type === 1  || 今日带离校学员 type === 2
export const queryUnSignStudentList =(params) => post('erp/studentCard/queryUnSignStudentList',params)

//获取校区师生关系
export const getPageTeacherStudentRelations =(params) => post('erp/relation/getPageTeacherStudentRelations',params)

//获取家长通绑定二维码  
export const bindCodeQrcode =(params) => post('erp/studentCard/bindCodeQrcode',params)
//获取家长通绑定二维码
export const querySchoolRewardRule =(params) => post('crm/base/baseReport/querySchoolRewardRule',params)

export const getUserTreeWithOutCampus =(params) => get('crm/account/getUserTreeWithOutCampus',params)
//业绩分单内获取人员
export const getAllUserTreeWithOutCampus =(params) => get('crm/account/getAllUserTreeWithOutCampus',params)
// 学习机用户列表
export const queryMachineStudentList =(params) => post('erp/student/queryMachineStudentList',params)
//带跟进
export const queryMachineFollowCount =(params) => post('erp/student/queryMachineFollowCount',params)
// 申请学员督学
export const applyStudentDuxue = params => post(  'erp/student/applyStudentDuxue',params)


/**
 * 服务中心学员
 */

// 列表
export const queryServicePointStudentList =(params) => post('erp/student/queryServicePointStudentList',params)

//带跟进
export const queryServicePointFollowCount =(params) => post('erp/student/queryServicePointFollowCount',params)
//批量分配服务人员
export const opBatchServicePointRelation =(params) => post('erp/relation/opBatchServicePointRelation',params)
//各督学状态数据汇总
export const queryServiceSupervisorStatusPointCount = (params) =>
post("erp/student/queryServiceSupervisorStatusPointCount", params);
//批量标记督学状态
export const updateStudentSupervisor = (params) =>
post("erp/student/updateStudentSupervisor", params);
//代理商新激活学员数量
export const queryActivationPointCount = (params) =>
post("erp/student/queryActivationPointCount", params);
//代理商新激活学员数量
export const getSupervisorInfosByStudentId = (params) =>
post("erp/student/getSupervisorInfosByStudentId", params);
// 为学生分配体验分析师
export const batchAddStudentTeacherRelation = (params) =>
  post("erp/relation/batchAddStudentTeacherRelation", params);
//待分配
export const servicePointWaitAssignCount =(params) => get('erp/student/servicePointWaitAssignCount',params)

// 服务人员列表
export const queryServiceTeacherList = (params) =>
  get("erp/relation/queryServiceTeacherList", params);
// 服务人员列表
export const deleteTeacherStudentRelation = (params) =>
  post("erp/relation/deleteTeacherStudentRelation", params);

//校验功能是否可用
export const checkNavLimit =(params) => post('rule/checkNavLimit',params)

//校验功能是否启用
export const checkFunctionLimit =(params) => post('rule/checkFunctionLimit',params)
